import moment from 'moment-timezone';

const getGranularity = (start, end) => {
  if (moment(end).diff(moment(start), 's') <= 1) {
    return 'ms';
  }
  if (moment(end).diff(moment(start), 'm') <= 1) {
    return 's';
  }
  return 'm';
};

export default getGranularity;
